import React, { ReactElement } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import useStylesCompletionBar from './completion-bar.styles';

const CompletionBar: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COLOR_SECONDARY: ThemeColor = 'secondary';
  const VARIANT_DETERMINATE: LinearProgressVariant = 'determinate';
  const PROGRESS_DEFAULT: number = 0;

  const {
    value,
  } = props;

  const { classes } = useStylesCompletionBar();

  return (
    <LinearProgress
      color={COLOR_SECONDARY}
      variant={VARIANT_DETERMINATE}
      classes={{
        root: classes.completionBar,
        colorSecondary: classes.completionBarBackground,
      }}
      value={value || PROGRESS_DEFAULT}
    />
  );
});

export default CompletionBar;
